import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const VersionHistory = ({ versions, currentVersionId, onSelectVersion }) => {
  if (!versions || versions?.length === 0) {
    return null;
  }

  return (
    <div className="bg-white rounded-2xl p-4 md:p-6 border border-[#E5E7EB]">
      <div className="flex items-center gap-3 mb-4 md:mb-6">
        <div className="w-8 h-8 md:w-10 md:h-10 rounded-lg flex items-center justify-center bg-[#F6F7FB]">
          <Icon name="History" size={20} color="#5B2DFF" />
        </div>
        <div>
          <h3 className="text-base md:text-lg font-semibold text-[#111827]">Version History</h3>
          <p className="text-xs md:text-sm text-[#6B7280]">{versions?.length} version{versions?.length > 1 ? 's' : ''} saved</p>
        </div>
      </div>
      <div className="space-y-3 md:space-y-4">
        {versions?.map((version, index) => {
          const isActive = version?.id === currentVersionId;
          const versionNumber = versions?.length - index;

          return (
            <div
              key={version?.id}
              className={`p-3 md:p-4 rounded-xl border-2 transition-all duration-250 ${
                isActive
                  ? 'border-[#5B2DFF] bg-[#5B2DFF]/5'
                  : 'border-[#E5E7EB] hover:border-[#5B2DFF]/30'
              }`}
            >
              <div className="flex items-start justify-between gap-3 mb-2">
                <div className="flex items-center gap-2">
                  <span className={`text-xs md:text-sm font-semibold px-2 py-1 rounded-full ${
                    isActive ? 'bg-[#5B2DFF] text-white' : 'bg-[#F6F7FB] text-[#6B7280]'
                  }`}>
                    v{versionNumber}
                  </span>
                  <span className="text-xs md:text-sm text-[#6B7280]">
                    {new Date(version.createdAt)?.toLocaleDateString('en-US', {
                      month: 'short',
                      day: 'numeric',
                      year: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit'
                    })}
                  </span>
                </div>
                {isActive && (
                  <span className="flex items-center gap-1 text-xs md:text-sm font-medium text-[#5B2DFF]">
                    <Icon name="CheckCircle" size={14} />
                    Active
                  </span>
                )}
              </div>
              <p className="text-sm md:text-base text-[#111827] line-clamp-2 mb-3">
                {version?.content}
              </p>
              <div className="flex items-center gap-2 md:gap-3 text-xs md:text-sm text-[#6B7280]">
                <span className="flex items-center gap-1">
                  <Icon name="FileText" size={14} />
                  {version?.wordCount} words
                </span>
                <span className="flex items-center gap-1">
                  <Icon name="Zap" size={14} />
                  {version?.tone}
                </span>
                <span className="flex items-center gap-1">
                  <Icon name="Target" size={14} />
                  {version?.emphasis}
                </span>
              </div>
              {!isActive && (
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => onSelectVersion(version?.id)}
                  className="mt-3 w-full"
                >
                  Use This Version
                </Button>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default VersionHistory;